import React, { useState, useEffect } from 'react';
import './Cryptotable.css'
import Coingecko from './assets/coingecko.png';

const Cryptotable = () => {
  const [currencies, setCurrencies] = useState([]);

  
  useEffect(() => {
    const fetchData = async () => {
      try {
      
        const priceUrl = `https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&order=market_cap_desc&per_page=20&page=1&sparkline=true&price_change_percentage=1h%2C24h%2C7d&locale=en`;

      
        const response = await fetch(priceUrl);
        const data = await response.json();
        
        
        setCurrencies(data);
      } catch (error) {
        console.error("Error fetching data: ", error);
      }
    };

    fetchData();
  }, []);

  return (
    
    <div className='table'>
        <div className='title'>
            <h1>Top Cryptocurrency Prices By Market Cap</h1>
            <p>Powered By <a href='https://www.coingecko.com'>Coingecko<img src={Coingecko} alt='gecko' /></a></p>
        </div>
      <table>
        <thead>
          <tr>
            <th>Coin</th>
            <th>Symbol</th>
            <th>Price</th>
            <th>24h Change</th>
            <th>Market Cap</th>
          </tr>
        </thead>
        <tbody>
          {currencies.length > 0 ? (
            currencies.map(currency => (
              <tr key={currency.id}>
                <td>
                  <img src={currency.image} alt={currency.name} width="30" />
                  {currency.name}
                </td>
                <td>{currency.symbol.toUpperCase()}</td>
                <td>${currency.current_price.toLocaleString()}</td>
                <td className={currency.price_change_percentage_24h < 0 ? 'negative' : 'positive'}>
                  {currency.price_change_percentage_24h.toFixed(2)}%
                </td>
                <td>${currency.market_cap.toLocaleString()}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5">Loading data...</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Cryptotable;
